import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "column" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Daily availability")
], -1)
const _hoisted_5 = { class: "column is-narrow" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_teams_dropdown = _resolveComponent("teams-dropdown")
  const _component_team_daily_calendar = _resolveComponent("team-daily-calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_teams_dropdown)
        ])
      ]),
      _hoisted_6,
      _createVNode(_component_team_daily_calendar)
    ])
  ]))
}